import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import { get, post } from '../Services/http';
import { catchError } from './Error.action';
import { pushToDatalayer } from '../wooscripts/gtmEnchanced';

export const REGISTER_ME_QUERY = "REGISTER_ME_QUERY";
export const REGISTER_ME_ERROR = "REGISTER_ME_ERROR";
export const REGISTER_ME_UPDATE = "REGISTER_ME_UPDATE";

const api = "/api/registerme/";
let abortController;

export const getFields = (type, token) => (dispatch) => {
   
    return get(`${api}GetFields/${token && "?token=" + token}`)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => searchError(error))));
}

export const saveMember = (data) => (dispatch, getState) => {

    return post(`${api}SaveMember/`, data)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                let gtm = {
                    event: "ecomOnRegisterationInsider"
                };
                pushToDatalayer(gtm);
            }
            dispatch(receive(result));
        })
        .catch(ex => dispatch(catchError(ex, error => searchError(error))));
}

export const getHtmlSnippet = () => (dispatch) => {
    
    return get(`${api}GetRegistrationHtmlSnippet/`)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => searchError(error))));
}

export const briqPayLogin = () => (dispatch) => {
    return post(`${api}BriqpayLogin/`)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => searchError(error))));
}

export const searchError = error => ({
    type: REGISTER_ME_ERROR,
    payload: {
        error,
    }
})

export const receive = (result) =>
({
    type: REGISTER_ME_QUERY,
    payload: {
        fields: result.fields,
        status: result.successText,
        htmlSnippet: result.htmlSnippet,
        briqpayLoginSuccess: result.success
    }
})
